import { Model } from "pinia-orm";

export default class AgencyGroup extends Model {
  static name = "AgencyGroup";
  static entity = "agencyGroups";

  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      name: this.string(""),
      code: this.attr(null),
    };
  }
}
